import React from 'react';
import { useTranslation } from 'react-i18next';
import Heading from 'components/Heading';
import Spinner from 'components/Spinner';
import Card from 'components/Card';
import Panel from 'components/Panel';
import useUniqueId from 'hooks/useUniqueId';
import { useFetchMyCalendarSettings } from './hooks/useFetchMyCalendarSettings';
import NoCalendarLinkedContent from './NoCalendarLinkedContent';
import CalendarLinkedContent from './CalendarLinkedContent';
function UserCalendarIntegration() {
  var _data$hasAccountLinke;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var titleId = useUniqueId();
  var _useFetchMyCalendarSe = useFetchMyCalendarSettings(),
    data = _useFetchMyCalendarSe.data,
    isLoading = _useFetchMyCalendarSe.isLoading;
  var hasAccountLinked = (_data$hasAccountLinke = data === null || data === void 0 ? void 0 : data.hasAccountLinked) !== null && _data$hasAccountLinke !== void 0 ? _data$hasAccountLinke : false;
  return /*#__PURE__*/React.createElement(Card, {
    role: "region",
    "aria-labelledby": titleId
  }, /*#__PURE__*/React.createElement(Panel, null, /*#__PURE__*/React.createElement(Heading, {
    as: "h2",
    mb: "s",
    id: titleId
  }, t('auto_join_settings_title')), isLoading ? /*#__PURE__*/React.createElement(Spinner, {
    dimmed: true
  }) : /*#__PURE__*/React.createElement(React.Fragment, null, !hasAccountLinked && /*#__PURE__*/React.createElement(NoCalendarLinkedContent, null), hasAccountLinked && data && /*#__PURE__*/React.createElement(CalendarLinkedContent, {
    settings: data
  }))));
}
export default UserCalendarIntegration;